/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Adam (Tuannd@rsupport.com)
 *
 * @description
 *
 * @created at Thu Oct 24 2024
 **/

import styled from "@emotion/styled";

import { Column, Row, Tab, TabContent } from "@/frameworks/designStuff/components";

export const Wrapper = styled(Column)`
	width: 232px;
	height: 232px;
	box-sizing: border-box;
	background: ${({ theme }) => theme.colors.neutral_00_100};
	padding: 12px;
	box-shadow:
		0px 8px 16px 0px rgba(0, 0, 0, 0.2),
		0px 0px 4px 0px rgba(0, 0, 0, 0.04);
	border-radius: 8px;
`;

export const RepresentativeWrapper = styled(Row)`
	align-items: center;
	width: 100%;
	justify-content: space-between;
`;

export const RepresentativeImg = styled.img`
	width: 28px;
	height: 28px;
	border-radius: 50%;
	object-fit: cover;
	cursor: pointer;
`;

export const ProfileImg = styled.img<{ isUsingImage: boolean }>`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	object-fit: cover;
	cursor: pointer;
	border: ${({ theme, isUsingImage }) => (isUsingImage ? `3px solid ${theme.colors.accent_40_100}` : "")};
`;

export const ProfileImgList = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	grid-gap: 10px;
	padding-top: 10px;
	justify-items: center;
	align-items: center;
	justify-content: center;
	align-content: center;
`;

export const WrapperTab = styled(Tab)`
	height: 42px;
	padding: 0px 2px !important;
	flex: 1;
`;

export const Action = styled(Row)`
	min-width: 32px;
	width: auto;
	justify-content: center;
	align-items: center;
	height: 42px;
	padding-bottom: 10px;
`;

export const WrapperTabContent = styled(TabContent)`
	height: 168px;
	overflow-y: auto;
	&::-webkit-scrollbar-thumb {
		background: ${({ theme }) => theme.colors.neutral_50_40};
		border-radius: 5px;
		background-clip: padding-box;
	}
	&::-webkit-scrollbar-track {
		background: none;
		background-clip: padding-box;
		-webkit-box-shadow: none;
	}
	&::-webkit-scrollbar {
		background-color: none;
	}
`;
